import React from "react";
import HorizontalScroll from "../../../react-components/shared/HorizontalScroll";
import currentTheme from "../../../react-themes/theme";
import useWindowTools from "../../../react-hooks/useWindowTools";

const theme = currentTheme();

const HorizontalScrollProductList = (props) => {
  const {isMobile} = useWindowTools();
  const {ProductList, className = "", style, ...additionalProps} = props;

  const listStyles = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridAutoFlow: "column",
    padding: "0 5px"
  };

  const itemStyles = {
    width: theme.product_cards[isMobile ? "mobile_cards" : "full"].cardWidth
  };

  const styleProps = {listStyles, itemStyles};

  return <HorizontalScroll
    showNavButtons={!isMobile}
    showScroll={false}
    className={className}
    style={style}
  >
    <ProductList {...additionalProps} {...styleProps}/>
  </HorizontalScroll>;
};

export default HorizontalScrollProductList;
